import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { AmrapMinimapSectionItem } from "./AmrapMinimapSectionItem";
import {
  BaseMinimapSectionItem,
  type MinimapSectionItemProps,
} from "./BaseMinimapSectionItem";
import { FreestyleMinimapSectionItem } from "./FreestyleMinimapSectionItem";
import { RegularMinimapSectionItem } from "./RegularMinimapSectionItem";
import { SupersetMinimapSectionItem } from "./SupersetMinimapSectionItem";
import { TimedMinimapSectionItem } from "./TimedMinimapSectionItem";

export const MinimapSectionItem = observer(function MinimapSectionItem(
  props: MinimapSectionItemProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const item = workoutEditStore.getGroupWorkoutItemById(props.id);

  if (item.groupType === "SUPER_SET") {
    return <SupersetMinimapSectionItem {...props} />;
  }

  switch (item.format) {
    case "REGULAR":
      return <RegularMinimapSectionItem {...props} />;
    case "AMRAP":
      return <AmrapMinimapSectionItem {...props} />;
    case "TIMED":
      return <TimedMinimapSectionItem {...props} />;
    case "FREESTYLE":
      return <FreestyleMinimapSectionItem {...props} />;
    default:
      return <BaseMinimapSectionItem {...props} />;
  }
});
